import React from 'react';
import { FieldErrors, SetFieldValue, UseFormRegister } from 'react-hook-form';

interface EmailInputProps {
	register: UseFormRegister<any>;
	label: string,
	name: string,
	setValue: SetFieldValue<any>;
	isRequired: boolean,
	errors: FieldErrors; // Generalized type to handle multiple field errors
	handleSteps: (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => void;
}

const EmailInput: React.FC<EmailInputProps> = ({ register, errors, handleSteps, label, name, setValue, isRequired }) => {
	return (
		<div>
			<label className="block text-sm font-light mb-2">
				{label} {isRequired ? '*' : ""}
			</label>
			<input
				type="text"
				{...register(name, {
					required: isRequired,
					pattern:
						/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
				})}
				className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
				placeholder="Email"
				onChange={(e) => {
					handleSteps(e, name),
					setValue(name, e.target.value)
				}}
			/>
			{errors.Email?.type === 'required' && (
				<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">
					This is required
				</span>
			)}
			{errors.Email?.type === 'pattern' && (
				<span role="alert" className="w-full text-red-500 bg-white text-xs px-3">
					Please enter a valid email id
				</span>
			)}
		</div>
	);
};

export default EmailInput;
